function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.562 11.692C27.4871 11.6327 26.788 11.1059 25.3136 11.1059C24.9243 11.1076 24.5358 11.1409 24.152 11.2055C23.8666 9.25354 22.2496 8.30185 22.1771 8.25915L21.7811 8.0313L21.5208 8.40629C21.1947 8.91002 20.9566 9.46531 20.8169 10.0486C20.5529 11.1628 20.7134 12.2094 21.2806 13.1041C20.5957 13.485 19.4971 13.5788 19.2748 13.5871H1.08556C0.610459 13.5877 0.224941 13.9709 0.222351 14.445C0.201135 16.0353 0.471107 17.6161 1.01897 19.1096C1.64556 20.7495 2.57774 21.9575 3.79053 22.6967C5.14954 23.5274 7.3575 24.002 9.86032 24.002C10.991 24.0056 12.1195 23.9034 13.2311 23.6971C14.7764 23.4139 16.2633 22.8749 17.6304 22.1022C18.7569 21.4512 19.7707 20.623 20.6326 19.6495C22.0737 18.0214 22.9322 16.2083 23.5706 14.5969C23.6562 14.5969 23.7419 14.5969 23.8251 14.5969C25.4028 14.5969 26.3731 13.9668 26.9081 13.4387C27.2637 13.102 27.5413 12.6917 27.7214 12.2367L27.8344 11.9068L27.562 11.692Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.77153 13.0555H5.20896C5.32652 13.0555 5.42178 12.9604 5.42178 12.8431V10.6763C5.42244 10.559 5.32768 10.4634 5.21016 10.4627C5.20978 10.4627 5.20935 10.4627 5.20896 10.4627H2.77153C2.65397 10.4627 2.55872 10.5578 2.55872 10.6751C2.55872 10.6755 2.55872 10.6759 2.55872 10.6763V12.8431C2.55872 12.9604 2.65397 13.0555 2.77153 13.0555Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.13043 13.0555H8.56787C8.68543 13.0555 8.78069 12.9604 8.78069 12.8431V10.6763C8.78134 10.559 8.68659 10.4634 8.56903 10.4627C8.56864 10.4627 8.56822 10.4627 8.56783 10.4627H6.1304C6.01218 10.4627 5.91638 10.5583 5.91638 10.6763V12.8431C5.91708 12.9606 6.01268 13.0555 6.13043 13.0555Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.54043 13.0555H11.9779C12.0954 13.0555 12.1907 12.9604 12.1907 12.8431V10.6763C12.1913 10.559 12.0966 10.4634 11.979 10.4627C11.9786 10.4627 11.9782 10.4627 11.9778 10.4627H9.54039C9.42283 10.4627 9.32758 10.5578 9.32758 10.6751C9.32758 10.6755 9.32758 10.6759 9.32758 10.6763V12.8431C9.32761 12.9604 9.42291 13.0555 9.54043 13.0555Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9101 13.0555H15.3475C15.4653 13.0555 15.5609 12.9606 15.5615 12.8431V10.6763C15.5615 10.5583 15.4657 10.4627 15.3475 10.4627H12.9101C12.7925 10.4627 12.6973 10.5578 12.6973 10.6751C12.6973 10.6755 12.6973 10.6759 12.6973 10.6763V12.8431C12.6973 12.9604 12.7926 13.0555 12.9101 13.0555Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.13046 9.93823H8.56789C8.6856 9.93757 8.78071 9.84212 8.78071 9.72464V7.55788C8.78071 7.44055 8.68541 7.34549 8.56789 7.34549H6.13046C6.01275 7.34549 5.9171 7.44036 5.91644 7.55788V9.72464C5.9171 9.84235 6.01251 9.93757 6.13046 9.93823Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.54045 9.93823H11.9779C12.0956 9.93757 12.1907 9.84212 12.1907 9.72464V7.55788C12.1907 7.44055 12.0954 7.34549 11.9779 7.34549H9.54045C9.4229 7.34549 9.32764 7.44059 9.32764 7.55788V9.72464C9.32764 9.84212 9.42274 9.93757 9.54045 9.93823Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9101 9.93823H15.3475C15.4655 9.93757 15.5609 9.84235 15.5615 9.72464V7.55788C15.5609 7.44036 15.4653 7.34549 15.3475 7.34549H12.9101C12.7925 7.34549 12.6973 7.44059 12.6973 7.55788V9.72464C12.6973 9.84212 12.7924 9.93757 12.9101 9.93823Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9101 6.81981H15.3475C15.4653 6.81981 15.5609 6.7249 15.5615 6.60742V4.43942C15.5609 4.32191 15.4653 4.22703 15.3475 4.22703H12.9101C12.7925 4.22703 12.6973 4.3221 12.6973 4.43942V6.60738C12.6973 6.7247 12.7926 6.81981 12.9101 6.81981Z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3094 13.0555H18.7469C18.8646 13.0555 18.9602 12.9606 18.9609 12.8431V10.6763C18.9609 10.5583 18.8651 10.4627 18.7469 10.4627H16.3094C16.1919 10.4627 16.0966 10.5578 16.0966 10.6751C16.0966 10.6755 16.0966 10.6759 16.0966 10.6763V12.8431C16.0966 12.9604 16.1919 13.0555 16.3094 13.0555Z",
  fill: "currentColor"
});

var SvgDocker = function SvgDocker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Docker.f50cd88d.svg";
export { ForwardRef as ReactComponent };